const digitsOnly = (value: string): string => value.replace(/\D/g, '');

const isRepeatingDigits = (s: string): boolean => /^(\d)\1+$/.test(s);

export const isValidCpf = (cpf: string): boolean => {
  const d = digitsOnly(cpf);
  if (d.length !== 11 || isRepeatingDigits(d)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(d[i], 10) * (10 - i);
  let check = (sum * 10) % 11;
  if (check === 10) check = 0;
  if (check !== parseInt(d[9], 10)) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(d[i], 10) * (11 - i);
  check = (sum * 10) % 11;
  if (check === 10) check = 0;
  return check === parseInt(d[10], 10);
};

const CNPJ_WEIGHTS_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_WEIGHTS_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const cnpjCheckDigit = (base: string, weights: number[]): number => {
  let sum = 0;
  for (let i = 0; i < weights.length; i++) {
    sum += parseInt(base[i], 10) * weights[i];
  }
  const mod = sum % 11;
  return mod < 2 ? 0 : 11 - mod;
};

export const isValidCnpj = (cnpj: string): boolean => {
  const d = digitsOnly(cnpj);
  if (d.length !== 14 || isRepeatingDigits(d)) return false;

  if (cnpjCheckDigit(d, CNPJ_WEIGHTS_1) !== parseInt(d[12], 10)) return false;
  return cnpjCheckDigit(d, CNPJ_WEIGHTS_2) === parseInt(d[13], 10);
};

export const formatBrazilTaxIdDisplay = (digitsRaw: string): string => {
  const d = digitsOnly(digitsRaw).slice(0, 14);
  if (!d.length) return '';
  if (d.length <= 11) {
    let out = '';
    for (let i = 0; i < d.length; i++) {
      if (i === 3 || i === 6) out += '.';
      if (i === 9) out += '-';
      out += d[i];
    }
    return out;
  }
  let out = '';
  for (let i = 0; i < d.length; i++) {
    if (i === 2 || i === 5) out += '.';
    else if (i === 8) out += '/';
    else if (i === 12) out += '-';
    out += d[i];
  }
  return out;
};

export const normalizeBrazilTaxIdForStripe = (raw: string): string | null => {
  const d = digitsOnly(raw || '');
  if (isValidCpf(d)) return d;
  if (isValidCnpj(d)) return d;
  return null;
};

export const filterPixHolderNameInput = (raw: string): string => raw.replace(/[^A-Za-z.-]/g, '');

export const isValidPixHolderName = (value: string): boolean => {
  const s = value.trim();
  if (s.length < 2) return false;
  return /^(?:[A-Za-z]{2}|[A-Za-z][A-Za-z.-]*[A-Za-z])$/.test(s);
};

export const pixEmail = (
  emailArg: string | undefined,
  billingDetails: { email?: string } | undefined,
  eventsData: any,
  analyticsParams: any,
): string =>
  [emailArg, billingDetails?.email, eventsData?.email, analyticsParams?.user_data?.email]
    .map((v) => (typeof v === 'string' ? v.trim() : ''))
    .find(Boolean) || '';
